import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import type { OperatorDocument } from 'src/apis/document-exchange/types';
import { useDocumentWithdraw } from 'src/apis/document-exchange/use-document-withdraw';
import { Button } from 'src/components/buttons-and-actions/button';
import { TableActions } from 'src/components/buttons-and-actions/table-actions';
import { Link } from 'src/components/navigation/link';
import { WithdrawDocumentModal } from 'src/pages/shippers/documents/components/withdraw-document-modal';

export const DocumentActions: FC<{
  refreshDocuments?: () => void;
  data: OperatorDocument;
  index: number;
}> = ({ refreshDocuments, index, data }) => {
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const withdrawLink = data._links.withdrawOperatorDocument?.href;
  const documentWithdraw = useDocumentWithdraw();

  useEffect(() => {
    if (!documentWithdraw?.response) return;
    setShowWithdrawModal(false);

    toast.success('Document withdrawn.');
    if (refreshDocuments) {
      refreshDocuments();
    }
    // oxlint-disable-next-line exhaustive-deps
  }, [documentWithdraw?.response]);

  return (
    <>
      <TableActions testId={data.operatorDocumentId}>
        {data.documentStatus === 'PUBLISHED' ? (
          <>
            {data._links.getOperatorDocumentVersionHistory ? (
              <Link to={`/shippers/documents/${data.operatorDocumentId}`}>
                Edit
              </Link>
            ) : null}

            {withdrawLink ? (
              <Button
                data-testid={`actions-dropdown-withdraw-${index}`}
                onClick={() => {
                  setShowWithdrawModal(true);
                }}
              >
                Withdraw
              </Button>
            ) : null}
          </>
        ) : null}
      </TableActions>

      {showWithdrawModal && withdrawLink && (
        <WithdrawDocumentModal
          documentWithdraw={documentWithdraw}
          withdrawLink={withdrawLink}
          onDismiss={() => setShowWithdrawModal(false)}
        />
      )}
    </>
  );
};
